import { generateUtilityClass, generateUtilityClasses } from '@mui/material'

export interface GlobalSearchFieldClasses {
  root: string
  autocomplete: string
  rightActions: string
}

export type GlobalSearchFieldClassKey = keyof GlobalSearchFieldClasses

export function getGlobalSearchFieldUtilityClass(slot: string) {
  return generateUtilityClass('GlobalSearchField', slot)
}

const globalSearchFieldClasses: GlobalSearchFieldClasses = generateUtilityClasses('GlobalSearchField', ['root', 'autocomplete', 'rightActions'])

export default globalSearchFieldClasses
